<template>
  <div>
    <div class="row mt-50">
      <div class="col-md-8 col-md-offset-2">
        <div class="card" id="wizardCard">
          <form-wizard ref="wizard"
                       shape="circle"
                       stepSize="xs"
                       @on-complete="wizardComplete"
                       @on-change="scrollToTop"
                       :error-color="primary"
                       :title="title"
                       :subtitle="computeCaption(fields_en['patient_registration_form'], $store.state.lang.value.toLowerCase())"
                       :color='primary'>

            <tab-content :title="computeCaption(fields_en['site'], $store.state.lang.value.toLowerCase())"
                         :before-change="validateFirstStep"
                         :route="currentRouteName + '/site-selection'"
                         icon="">
              <first-step ref="firstStep" @disabledSubmitButton="disabledSubmitButton" :siteCodeCaption="currentRouteName === '/patient/register' ? 'Office Location Code:' : 'Enter your zip code as office location code:'"
                          v-on:jumpToTheNextPage="jumpToTheNextPage">
              </first-step>
            </tab-content>

            <tab-content v-if="allow_disclaimer"
                         :title="computeCaption(fields_en['disclaimer'], $store.state.lang.value.toLowerCase())"
                         :before-change="validateSecondStep"
                         :route="currentRouteName + '/disclaimer'"
                         icon="">
              <second-step ref="secondStep"
                           v-on:nextTab="nextTab">
              </second-step>
            </tab-content>

            <tab-content v-if="allow_consent"
                         :title="computeCaption(fields_en['consent'], $store.state.lang.value.toLowerCase())"
                         :before-change="validateThirdStep"
                         :route="currentRouteName + '/consent'"
                         icon="">
              <third-step ref="thirdStep"
                           v-on:nextTab="nextTab">
              </third-step>
            </tab-content>

            <tab-content :title="computeCaption(fields_en['medical_data'], $store.state.lang.value.toLowerCase())"
                         :before-change="validateForthStep"
                         :route="currentRouteName + '/medical-data'"
                         icon="">
              <forth-step ref="forthStep"
                          :triggerWatch="triggerWatch"
                          v-on:nextTab="nextTab"
              ></forth-step>
            </tab-content>

            <tab-content v-if="allow_insurance"
                         :title="computeCaption(fields_en['payment_information'], $store.state.lang.value.toLowerCase())"
                         :before-change="validateFifthStep"
                         :route="currentRouteName + '/insurance'"
                         icon="">
              <fifth-step ref="fifthStep"
                          v-on:nextTab="nextTab"
              ></fifth-step>
            </tab-content>

            <tab-content v-if="allow_payment_process"
                         :title="computeCaption(fields_en['payment_process'], $store.state.lang.value.toLowerCase())"
                         :before-change="validateSeventhStep"
                         :route="currentRouteName + '/payment/process'"
                         icon="">
              <seventh-step ref="seventhStep"
                          v-on:nextTab="nextTab"
              ></seventh-step>
            </tab-content>

            <tab-content v-if="allow_telehealth"
                         :title="computeCaption(fields_en['submission'], $store.state.lang.value.toLowerCase())"
                         :before-change="validateSixthStep"
                         :route="currentRouteName + '/telehealth'"
                         icon="">
              <sixth-step ref="sixthStep"
                          v-on:nextTab="nextTab"
              ></sixth-step>
            </tab-content>
            <tab-content v-if="allow_schedules"
                         :title="'Appointment'"
                         :before-change="validateEighthStep"
                         :route="currentRouteName + '/appointment'">
              <eighth-step v-if="this.$store.state.site.code !== '' && this.$store.state.site.schedule.data.length"
                               ref="EighthStep"
                               v-on:nextTab="nextTab"></eighth-step>
            </tab-content>
            <button slot="prev" class="btn btn-default btn-wd btn-back primary-color"><span>{{computeCaption(fields_en['back'], $store.state.lang.value.toLowerCase())}} </span></button>
            <button slot="next" :disabled="submit" class="btn btn-fill btn-wd btn-next"><span>{{computeCaption(fields_en['next'], $store.state.lang.value.toLowerCase())}} </span></button>
            <button slot="finish" :disabled="disabled" class="btn btn-info btn-fill btn-wd btn-submit"><span>{{computeCaption(submitButtonText, $store.state.lang.value.toLowerCase())}} </span></button>
          </form-wizard>

          <div class="row">
            <div class="col-md-12">
              <p v-if="allow_results || allow_registration || allow_kit" class="m-50">
                <a v-if="allow_results" aria-label="Link to check results" href='#' role="link" v-on:click.stop.prevent="$router.push({path:'/patient/check-results'})" class="primary-color">{{computeCaption(fields_en['results'], $store.state.lang.value.toLowerCase())}}</a> <a v-if="allow_kit">|</a>
                <a v-if="allow_kit" aria-label="Link to kit registration" href='#' role="link" v-on:click.stop.prevent="$router.push({path:'/patient/kit'})" class="primary-color">{{computeCaption(fields_en['kit'], $store.state.lang.value.toLowerCase())}}</a>
               </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import variables from '../../../../assets/sass/paper/_variables.scss'
  import {FormatterUtils} from '../../../../utils/Formatter.js'
  import FirstStep from './Wizard/SiteSelectionStep.vue'
  import SecondStep from './Wizard/DisclaimerStep.vue'
  import ThirdStep from './Wizard/ConsentStep.vue'
  import ForthStep from './Wizard/MedicationDataStep.vue'
  import FifthStep from './Wizard/InsuranceStep.vue'
  import SixthStep from './Wizard/SubmissionStep.vue'
  import SeventhStep from './Wizard/PaymentStep.vue'
  import swal from 'sweetalert2'
  import axios from 'axios'
  import VueBarcode from 'vue-barcode'
  import {TranslationsUtils} from '../../../../utils/Translations'
  import {PatientInfoUtils} from '../../../../utils/PatientInfo'
  import EighthStep from '../Utils/ScheduleSection'
  export default {
    data () {
      return {
        currentRouteName: '',
        triggerWatch: false,
        redirectUrl: '',
        confirmationNumber: '',
        primary: variables.primaryColor,
        secondary: variables.secondaryColor,
        saveRegistrationCompleted: false,
        allow_payment_process: false,
        submit: false,
        allow_schedules: false,
        fields_en: {
          next: 'Next',
          back: 'Back',
          i_agree_and_submit: 'Submit',
          patient_registration_form: 'Patient Registration Form',
          payment_process: 'Payment Process',
          site: 'Site',
          medical_data: 'Medical Data',
          disclaimer: 'Disclaimer',
          payment_information: 'Payment Information',
          submission: 'Submission',
          results: 'Check your results',
          registration: 'Register as a new patient',
          kit: 'Register kit',
          consent: 'Consent'
        },
        disabled: false,
        wizardModel: {}
      }
    },
    mixins: [FormatterUtils, TranslationsUtils, PatientInfoUtils],
    components: {
      EighthStep,
      FirstStep,
      SecondStep,
      ThirdStep,
      ForthStep,
      FifthStep,
      SixthStep,
      SeventhStep,
      'barcode': VueBarcode
    },
    mounted: function () {
      window.document.title = this.title + ' Register Patient - Site Code Step'
      this.$sidebar.isMinimized = true
      this.$nextTick(() => {
        const elements = document.getElementsByClassName('wizard-nav-pills')[0].getElementsByTagName('li')
        for (let i = 0; i < elements.length; i++) {
          elements[i].setAttribute('role', 'tab')
          let aList = elements[i].querySelectorAll('a')
          let divList = aList[0].querySelectorAll('div')
          divList[0].removeAttribute('role')
          divList[0].removeAttribute('tabindex')
          let id = divList[0].getAttribute('id')
          divList[0].setAttribute('aria-controls', id)
        }
      })
    },
    methods: {
      nextTab () {
        this.$refs.wizard.nextTab()
      },
      redirectConfirmationNumberPage () {
        if (this.$store.state.redirect_registration_url && this.$store.state.redirect_registration_url.includes('{{')) {
          let redirectUrl = this.$store.state.redirect_registration_url
          redirectUrl = redirectUrl.replace('site_code', this.$store.state.site.code)
          redirectUrl = redirectUrl.replace('confirmation_number', this.confirmationNumber)
          redirectUrl = redirectUrl.replace('first_name', this.$store.state.dataForInsurance.first_name)
          redirectUrl = redirectUrl.replace('last_name', this.$store.state.dataForInsurance.last_name)
          redirectUrl = redirectUrl.replaceAll('{{', '')
          redirectUrl = redirectUrl.replaceAll('}}', '')
          this.redirectUrl = redirectUrl
        } else {
          if (this.$store.state.redirect_registration_url) {
            this.redirectUrl = ''
          } else {
            this.redirectUrl = ''
          }
        }
      },
      jumpToTheNextPage () {
        // this method will jump to the next page without any validation
        // do not use it
        this.$refs.wizard.changeTab(0, 1)
      },
      async saveRegistration (data) {
        let info = await this.getPatientInfo()
        data.firstName = data.firstName.replace(/^\s+|\s+$|\s+(?=\s)/g, '')
        data.lastName = data.lastName.replace(/^\s+|\s+$|\s+(?=\s)/g, '')
        data['paid_cash'] = this.$store.state.cashPayment
        data['patient_support_info'] = this.$store.state.configs.PATIENT_SUPPORT_INFO
        data['redirect_payment_url'] = this.$store.state.redirect_payment_url
        data.info = info
        this.submit = true
        const self = this
        axios.post(process.env.SERVER_URI + '/register/' + this.$store.state.site.code, data)
        .then((response) => {
          if (response.data.schedule) {
            swal({
              html: `<h4>` + response.data.schedule + `</h4>
                           <br>`,
              icon: 'error',
              type: 'error',
              confirmButtonText: 'Ok',
              showCancelButton: false,
              showConfirmButton: true,
              width: 700
            })
            self.redirect()
            return
          }
          if (response.data === false) {
            swal('Error!', 'There was an error submitting the data', 'error')
            self.redirect()
          } else {
            if (response.data['template'] === undefined && response.data.includes('card')) {
              swal('Error!', response.data, 'error')
              self.redirect()
              return
            }
            if (response.data['template'] === undefined) {
              swal('Error!', 'There was an error submitting the data', 'error')
              self.redirect()
              return
            }
            if (this.$store.state.cashPayment && (this.$store.state.configs['FORCE_PAYMENT_ON_REGISTRATION'] === false && this.$store.state.configs['AT_HOME_COLLECTION'] === false)) {
              // redirect to custom payment
              if (this.$store.state.redirect_payment_url) {
                window.location.href = self.$store.state.redirect_payment_url + response.data['confirmation_number']
              } else {
                this.$router.push({ name: 'PaymentWizard', params: {id: response.data['confirmation_number']} })
              }
            } else {
              this.confirmationNumber = response.data['confirmation_number']
              let template = response.data['template']
              let url = this.$store.state.redirect_registration_url
              let redirectUrl = this.redirectUrl
              if (this.$store.state.redirect_registration_url && this.$store.state.redirect_registration_url.includes('{{')) {
                this.redirectConfirmationNumberPage()
                setTimeout(() => {
                  swal({
                    html: template + `
                               </b>
                           <br>
                           <div class="flex">
                          <button type="button" style="background: #509119" class="btn-modal btn-complete">` + this.computeCaption('Complete', this.$store.state.lang.value.toLowerCase()) + `</button>
                          <button type="button" style="background: #0E62AA" class="btn-modal btn-new-patient">` + this.computeCaption('Register New Patient', this.$store.state.lang.value.toLowerCase()) + `</button>
                          </div>`,
                    showCancelButton: false,
                    showConfirmButton: false,
                    width: 700,
                    onBeforeOpen: () => {
                      const complete = document.querySelector('.btn-complete')
                      const patient = document.querySelector('.btn-new-patient')

                      complete.addEventListener('click', () => {
                        window.location.assign(window.origin + '/#/')
                        window.location.reload()
                        swal.close()
                      })

                      patient.addEventListener('click', () => {
                        window.location.assign(window.origin + '/#/patient/register/site-selection?site_code=' + this.$store.state.sitecode)
                        window.location.reload()
                        swal.close()
                      })
                    }
                  }).catch(swal.noop)
                }, 1000)
              } else {
                this.redirectConfirmationNumberPage()
                setTimeout(() => {
                  swal({
                    html: template + `
                               </b>
                           <br>
                           <div class="flex">
                          <button type="button" style="background: #509119" class="btn-modal btn-complete">` + this.computeCaption('Complete', this.$store.state.lang.value.toLowerCase()) + `</button>
                          <button type="button" style="background: #0E62AA" class="btn-modal btn-new-patient">` + this.computeCaption('Register New Patient', this.$store.state.lang.value.toLowerCase()) + `</button>
                          </div>`,
                    showCancelButton: false,
                    showConfirmButton: false,
                    width: 700,
                    onBeforeOpen: () => {
                      const complete = document.querySelector('.btn-complete')
                      const patient = document.querySelector('.btn-new-patient')

                      complete.addEventListener('click', () => {
                        if (redirectUrl === '' && url) {
                          window.location.assign(url)
                          window.location.reload()
                        } else {
                          window.location.assign(window.origin + '/#/')
                          window.location.reload()
                        }
                        swal.close()
                      })

                      patient.addEventListener('click', () => {
                        window.location.assign(window.origin + '/#/patient/register/site-selection?site_code=' + this.$store.state.sitecode)
                        window.location.reload()
                        swal.close()
                      })
                    }
                  }).catch(swal.noop)
                }, 1000)
              }
            }
          }
        }).catch(error => {
          if (error.response && error.response.status !== 429) {
            swal('Error!', 'There was an error submitting the data', 'error')
            .then(function (result) {
              window.location.reload()
            })
            self.redirect()
          }
        })
      },
      redirect () {
        const body = document.querySelector('body')
        body.onclick = function () {
          window.location.reload()
        }
      },
      validateFirstStep () {
        this.triggerWatch = !(this.allow_disclaimer && this.allow_consent)
        return this.$refs.firstStep.validate()
      },
      validateSecondStep () {
        this.triggerWatch = !this.allow_consent
        return this.$refs.secondStep.validate()
      },
      validateThirdStep () {
        this.triggerWatch = true
        return this.$refs.thirdStep.validate()
      },
      validateForthStep () {
        return this.$refs.forthStep.validate()
      },
      validateFifthStep () {
        return this.$refs.fifthStep.validate()
      },
      validateSixthStep () {
        return this.$refs.sixthStep.validate()
      },
      validateSeventhStep () {
        return this.$refs.seventhStep.validate()
      },
      validateEighthStep () {
        return this.$refs.EighthStep.validate()
      },
      wizardComplete: function () {
        this.disabled = true
        // we gather models from all steps into one model
        if (!this.saveRegistrationCompleted) {
          Object.assign(this.wizardModel, this.$refs.firstStep.model)
          if (this.allow_disclaimer) {
            Object.assign(this.wizardModel, this.$refs.secondStep.model)
          }
          if (this.allow_consent) {
            Object.assign(this.wizardModel, this.$refs.thirdStep.model)
          }
          Object.assign(this.wizardModel, this.$refs.forthStep.model)
          if (this.allow_insurance) {
            Object.assign(this.wizardModel, this.$refs.fifthStep.model)
          }
          if (this.allow_schedules) {
            Object.assign(this.wizardModel, {appointment_date: this.$refs.EighthStep.selectedDate, appointment_slot_id: this.$refs.EighthStep.time.id})
          }
          if (this.allow_payment_process) {
            Object.assign(this.wizardModel, this.$refs.seventhStep.model)
          }
          if (this.allow_telehealth) {
            Object.assign(this.wizardModel, this.$refs.sixthStep.model)
          }
          this.wizardModel.questions = this.$store.state.questions
          this.saveRegistrationCompleted = true
          this.saveRegistration(this.wizardModel)
        }
      },
      disabledSubmitButton (booleanValue) {
        this.submit = booleanValue
      },
      scrollToTop () {
        let elmnt = document.getElementsByClassName('main-panel')[0]
        let buttons = document.getElementsByClassName('btn-fill')
        // reset focus from the buttons after each step
        for (let i = 0; i < buttons.length; i++) {
          buttons[i].blur()
        }
        elmnt.scrollTo(0, 0)
        this.$refs.wizard.tabs.forEach(element => {
          if (element.active) {
            window.document.title = this.title + ' ' + element.title + ' Step'
          }
        })
      }
    },
    computed: {
      allow_disclaimer () {
        return this.$store.state.configs.ALLOW_DISCLAIMER
      },
      allow_consent () {
        return this.$store.state.configs.ALLOW_CONSENT
      },
      allow_results () {
        return this.$store.state.configs.ALLOW_RESULTS
      },
      allow_registration () {
        return this.$store.state.configs.ALLOW_REGISTRATION
      },
      allow_kit () {
        return this.$store.state.configs.ALLOW_KIT_REGISTRATION
      },
      allow_insurance () {
        return this.$store.state.configs.ALLOW_INSURANCE
      },
      allow_telehealth () {
        return this.$store.state.configs.ALLOW_TELEHEALTH
      },
      title () {
        return this.$store.state.configs.LAB_NAME
      },
      submitButtonText () {
        if (this.submit) {
          return 'Submitting.. Please wait'
        }
        if (this.$store.state.cashPayment === 'card') {
          return 'Submit and PAY'
        }
        return 'Submit'
      }
    },
    beforeMount () {
      if (!window.location.href.includes('/patient/register-home-collection')) {
        this.currentRouteName = '/patient/register'
      } else {
        this.currentRouteName = '/patient/register-home-collection'
      }
    },
    created () {
      if (window.location.href.includes('/patient/register') && this.$store.state.configs['SINGLE_PAGE_ORDERS'] === true) {
        window.location.href = window.origin + '/#/patient/order'
        window.location.reload()
      }
    },
    watch: {
      '$store.state.insuranceType': {
        handler: function (val) {
          if (val !== 'cash') {
            return
          }
          if ((this.$store.state.configs['FORCE_PAYMENT_ON_REGISTRATION'] === true && this.$store.state.insuranceType === 'cash') || this.$store.state.configs['AT_HOME_COLLECTION'] === true) {
            this.allow_payment_process = true
          }
        }
      },
      '$store.state.cashPayment': {
        handler: function (val) {
          if (val !== 'card' && this.$store.state.configs['AT_HOME_COLLECTION'] === false) {
            this.allow_payment_process = false
            return
          }
          if ((this.$store.state.configs['FORCE_PAYMENT_ON_REGISTRATION'] === true && this.$store.state.insuranceType === 'cash') || this.$store.state.configs['AT_HOME_COLLECTION'] === true) {
            this.allow_payment_process = true
          }
        },
        deep: true
      },
      '$store.state.paymentProcess': {
        handler: function (val) {
          this.allow_payment_process = val
        },
        deep: true
      },
      '$store.state.allowSchedules': {
        handler: function (val) {
          this.allow_schedules = val
        },
        deep: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../../assets/sass/paper/_variables.scss';

  .m-50{
    margin-top: 20px;
    padding-bottom: 20px;
    margin-left: 20px;
  }

  .vue-form-wizard .wizard-nav-pills>li>a.disabled {
    color: $secondary-color;
  }

  .vue-form-wizard .wizard-icon-circle {
    background-color: white;
    color: $secondary-color;
    border: 3px solid $secondary-color;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Patient/RegistrationWizard.vue